import * as React from 'react'
import TextField from '@mui/material/TextField'
import useStyleAddExtensionModal from './Styles/useStyleAddExtensionModal'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Modal, Typography } from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { addFileExtends } from '../../../../redux/actions/Security'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 200,
  bgcolor: 'white',
  p: 4,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export default function AddExtensionModal ({ openAddModal, setOpenAddModal }) {
  const classes = useStyleAddExtensionModal()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [extension, setExtension] = useState('.')
  const [error, setError] = useState('')

  const handleClose = () => {
    setOpenAddModal(false)
  }

  const handleChange = (e) => {
    setExtension(e.target.value.toLowerCase())
    setError('')
  }

  const handleAddExtend = async () => {
    if (extension === '' || extension === '.') {
      return setError('Ingrese la extensión')
    }
    const formatNewExtension = extension.split('.')[1]
    if (!formatNewExtension) return 'Ocurrió un error. Recargue la página'
    if (formatNewExtension === 'exec') {
      return setError('Extensión de archivo no permitida')
    }
    await dispatch(addFileExtends(formatNewExtension))
    setOpenAddModal(false)
    setTimeout(() => {
      navigate(0)
    }, 2000)
  }

  return (
    <div>
      <Modal
        open={openAddModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: 'medium',
              ml: 50,
              color: '#263057',
              cursor: 'pointer'
            }}
            onClick={handleClose}
          />
          <Typography
            sx={{ fontFamily: 'Raleway', color: '#263057' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Habilitar extensión
          </Typography>
          <Typography
            id="modal-modal-description"
            className={classes.typography}
          >
            Ingrese el tipo de extensión que desea agregar
          </Typography>
          <TextField
            sx={{ width: '20%' }}
            autoFocus
            margin="dense"
            id="name"
            type="text"
            value={extension}
            onChange={handleChange}
            variant="standard"
          />

          <Box className={classes.buttons}>
            <ButtonConfirm handleAddExtend={handleAddExtend} />
            <ButtonClose handleClose={handleClose} />
          </Box>
          <Typography sx={{ color: 'red' }}>{error}</Typography>
        </Box>
      </Modal>
    </div>
  )
}

function ButtonConfirm ({ handleAddExtend }) {
  const classes = useStyleAddExtensionModal()
  return (
    <Box
      className={classes.confirmButton}
      sx={{
        '&:hover': {
          bgcolor: '#1BF57F'
        }
      }}
    >
      <Typography
        onClick={handleAddExtend}
        className={classes.confirmButtonTypography}
      >
        Agregar
      </Typography>
    </Box>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyleAddExtensionModal()
  return (
    <Box className={classes.closeButton}>
      <Typography
        onClick={() => {
          handleClose()
        }}
        className={classes.closeButtonColor}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
